import { getPercetageValue } from '../../utils';

const TOTAL_STUDY_HOURS = 6;
export const TOTAL_STUDY_MINUTES = TOTAL_STUDY_HOURS * 60;

export const getHoursArray = () => Array.from(Array(TOTAL_STUDY_HOURS).keys());

export const getRulerDividerLeftOffset = (index: number): string =>
  `${index * (100 / (TOTAL_STUDY_HOURS - 1))}%`;

export const getLabelXValue = (index: number): string => {
  if (index === 0) {
    return '-2px';
  } else if (index === TOTAL_STUDY_HOURS - 1) {
    return '-80%';
  } else {
    return '-45%';
  }
};

type StudyTimeProgressValues = {
  timeSpent: number;
  timeRemaining: number;
  timeSaved: number;
};

export const getStudyTimeProgressPercentage = ({
  timeSpent,
  timeRemaining,
  timeSaved,
}: StudyTimeProgressValues) => {
  const timeSpentPercentage = getPercetageValue(TOTAL_STUDY_MINUTES, timeSpent);
  const timeRemainingPercentage = getPercetageValue(TOTAL_STUDY_MINUTES, timeRemaining);
  const timeSavedPercentage = getPercetageValue(TOTAL_STUDY_MINUTES, timeSaved);

  return { timeSpentPercentage, timeRemainingPercentage, timeSavedPercentage };
};
